<template>
    <Dialog :value="show" @input="$listeners.input" title="Esqueci minha senha" width="450" show-close-button>
        <p class="description-text">
            Preencha os dados solicitados abaixo para receber a nova senha da plataforma de vendas no seu e-mail.
        </p>
        <p>
            <strong>Atenção:</strong> A senha alterada não será a do Escritório Digital.
        </p>
        <m-form ref="formForgotPassword" class="pt-4" @submit.prevent="enviar">
            <m-text-field ref="input_cpf_cnpj_esqueci_senha"
                          id="FieldIdentificadorUsuario"
                          label="Informe o CPF/CNPJ:"
                          class="required"
                          autocomplete="off"
                          color="default_primary_color"
                          :dense="hasEmail"
                          :filled="hasEmail"
                          :disabled="hasEmail"
                          :hide-details="hasEmail"
                          v-mask="['###.###.###-##','##.###.###/####-##']"
                          hint="Não é necessário colocar pontos ou traços!"
                          v-model="identificadorUsuario"
                          @change="usuarioExiste = true"
                          :rules="[$rules.required, usuarioExiste,$rules.cpf_cnpj]"
                          maxlength="18"
                          outlined />
            <div class="d-flex flex-column mt-3 mb-n5" v-if="hasEmail">
                Confirme o e-mail para alterar a senha:  <br> <strong style="font-size:14px">{{ censoredEmail }}</strong>
            </div>
            <v-text-field ref="input"
                          id="FieldConfirmaEmail"
                          class="required"
                          v-if="hasEmail"
                          color="default_primary_color"
                          autocomplete="off"
                          v-model="emailConfirmacao"
                          @change="emailsConcidem = true"
                          :rules="[$rules.required,emailsConcidem]"
                          maxlength="200"
                          outlined>
            </v-text-field>
            <div class="d-flex justify-end">
                <v-btn x-large class="button btn-default" type="submit">{{ hasEmail ? 'Confirmar' : 'Prosseguir' }}</v-btn>
            </div>
        </m-form>
    </Dialog>
</template>

<script>
  import { unmask, alert, notification } from '../plugins/helpers'

  export default {
    name: 'DialogForgotPasword',
    props: { value: Boolean },
    data: () => ({
      identificadorUsuario: '',
      censoredEmail: '',
      usuarioExiste: true,
      emailsConcidem: true,
      emailConfirmacao: '',
      email: ''
    }),
    computed: {
      show: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      },
      hasEmail () {
        return this.email !== ''
      }
    },
    watch: {
      value (value) {
        this.reset()
      }
    },
    methods: {
      reset () {
        this.identificadorUsuario = ''
        this.email = ''
        this.emailConfirmacao = ''
        this.censoredEmail = ''
        this.usuarioExiste = true
        this.emailsConcidem = true
        this.$refs.input_cpf_cnpj_esqueci_senha.resetValidation()
      },
      async enviar () {
        const form = this.$refs.formForgotPassword
        if (form.validate()) {
          if (!this.hasEmail) {
            await this.getEmail()
          } else {
            await this.resetPassword()
          }
        } else {
          return false
        }
      },
      async getEmail () {
        await this.$http.get(`/validacao_usuario/${unmask(this.identificadorUsuario)}`)
          .then((response) => {
            const { email, pessoa_existe, censoredEmail, pessoa_existe_email_nao_existe } = response.data
            if (!pessoa_existe && !pessoa_existe_email_nao_existe) {
              this.usuarioExiste = 'Usuário não encontrado!'
              return
            } else if (pessoa_existe_email_nao_existe) {
              notification('warning', 'Caro parceiro, não foi encontrado nenhum e-mail cadastrado no Newcon para seu usuário, tente novamente e caso o problema persistir entre em contato com a Área de Suporte.')
              return
            }
            this.censoredEmail = censoredEmail
            this.email = atob(email)
          }).catch(() => {
            notification('error', 'Caro parceiro, foi encontrado um problema ao consultar seu usuário, sugerimos tentar novamente e se o problema persistir entre em contato com a Área de Suporte.')
          })
      },
      async resetPassword () {
        if (this.emailConfirmacao.toLowerCase() !== this.email.toLowerCase()) {
          this.emailsConcidem = 'E-mail digitado não coincide com e-mail cadastrado'
          return
        }

        await this.$http.post(`/esqueci_senha`, { identificadorUsuario: unmask(this.identificadorUsuario) }).then((response) => {
          alert(response.data.Msg)
          this.show = false
        }).catch((err) => {
          alert(err.response.data.Msg_Erro ?? 'Não foi possível gerar a nova senha para acesso. Tente novamente mais tarde e caso o erro persistir, entre em contato com a Área de Suporte')
        })
      }
    }
  }
</script>

<style scoped>
.description-text{
    color:var(--default_primary_color);
    text-align: justify;
    font-size: 1rem;
  }
  .button {
    background: linear-gradient(45deg, #018D9E, #0E294C) !important;
    color: white !important;
    border-radius: 25px;
}
</style>
